import { BudgetProvider } from 'hooks'
import type { DefaultProps } from 'typings'
import { ConditionsContextProvider } from '../components/PromotionForm/Conditions/ConditionsContext'
import { RestrictionsProvider } from '../components/PromotionForm/Restrictions/hooks/useRestrictions.constate'
import { FormValidationContextProvider } from './FormValidationContext'
import { FormAliasProvider } from './useFormAlias.constate'

export function FormProviders(props: DefaultProps) {
  return (
    <FormAliasProvider>
      <FormValidationContextProvider>
        <ConditionsContextProvider>
          <RestrictionsProvider>
            <BudgetProvider>{props.children}</BudgetProvider>
          </RestrictionsProvider>
        </ConditionsContextProvider>
      </FormValidationContextProvider>
    </FormAliasProvider>
  )
}
